//Global keys
let locales = {
};

//Merge Modules
import admin from '../../admin/.config/lan/es'
import ModalAffiliatePartner from '../../../components/ModalAffiliatePartner/.config/lan/es'

locales = {
    ...locales,
    ...admin,
    ...ModalAffiliatePartner
};

export default locales;